import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDatepickerInputEvent, MatDatepicker, MatDialog } from '@angular/material';
import * as moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { InfoDialogComponent } from '../../dialogs/info-dialog/info-dialog.component';
import { AuthenticationService } from '../../services/authentication.service';
import { UiService } from '../../services/ui.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-bimbo-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  model: any = { email: '', employeeNumber: '', password: '', passwordConf: '', seniorityDate: new Date() };
  seniorityDate: Date | null = null;
  seniorityDateO: Date | null = null;
  authEmployeeSubscription: Subscription = null;

  constructor(public dialog: MatDialog, private authService: AuthenticationService, private ui: UiService, public snackBar: MatSnackBar, private router: Router) {

    this.authEmployeeSubscription = this.authService.authUserSubject.subscribe(anEmployee => {

      if (anEmployee) {

        this.ui.stopSpinner();

        this.snackBar.open('Bienvenido.', null, {
          duration: 3000,
          panelClass: ['green-snackbar']
        });

        const path = this.authService.appLevel.sideBarItems[0].path;

        if (this.authService.href) {
          const url = this.authService.href;
          this.authService.href = null;
          this.router.navigate([url]);
        } else {
          this.router.navigate([path]);
        }

      }

    });
  }

  ngOnInit() {
  }

  chosenYearHandler(normalizedMoment: moment.Moment) {
    const ctrlValue = normalizedMoment.year();
    this.seniorityDateO = new Date();
    this.seniorityDateO.setFullYear(ctrlValue);
  }

  chosenMonthHandler(normalizedMoment: moment.Moment, datepicker: MatDatepicker<moment.Moment>) {
    const ctrlValue = normalizedMoment.month();
    this.seniorityDateO.setMonth(ctrlValue);
    this.seniorityDate = new Date(this.seniorityDateO.setMonth(ctrlValue));

    datepicker.close();
  }

  onEnter() {

    if (!this.model.employeeNumber) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Debe de ingresar el número de Colaborador o un correo válido.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.seniorityDate) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Debe de ingresar el año y mes de su ingreso a Grupo Bimbo.',
          close: 'Aceptar'
        }
      });

      return;
    }

    const same = this.model.password !== this.model.passwordConf;
    if (same) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'La contraseña y la confirmación no son iguales.',
          close: 'Aceptar'
        }
      });

      return;

    }
    this.seniorityDate.setDate(15);

    this.model.seniorityDate = this.seniorityDate.toISOString();

    this.authService.signIn(this.model).then(result => {

      this.ui.stopSpinner();
      if (!result) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'La información es invalida',
            close: 'Aceptar'
          }
        });
      }

    }).catch(error => {

      this.ui.stopSpinner();

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: error,
          close: 'Aceptar'
        }
      });

    });

  }

  ngOnDestroy(): void {

    if (this.authEmployeeSubscription && !this.authEmployeeSubscription.closed) {
      this.authEmployeeSubscription.unsubscribe();
      this.authEmployeeSubscription = null;
    }

  }

}
